import React, { useState } from 'react';
import FaqReferral from './ReferralFaqContent';
import FaqContact from './ContactFaqContent';
import FaqSafety from './SafetyFaqContent';
import _ from 'lodash';
import FaqDropdownContent from './FaqDropdownContent';
import {
  FaqSignupContent,
  faqCategories,
  faqEVContent,
  faqEligibilityContent,
  faqGeneralContent
} from './helperFunctions';

const FaqDropdown = ({
  isSearch,
  searchVal,
  closeSearch,
  setInput,
  setSearchVal,
  searchResult,
  setSearchResult,
  city
}) => {
  const [category, setCategory] = useState('');
  const [selected, setSelected] = useState([]);

  const handleSelected = cat => {
    let newSelected = [...selected];
    const included = _.includes(
      JSON.stringify(newSelected),
      JSON.stringify(cat)
    );
    included
      ? _.remove(newSelected, category => category === cat)
      : newSelected.push(cat);
    _.remove(newSelected, category => category !== cat);
    setSelected(newSelected);
  };

  const categories = faqCategories(city);

  var filteredCategories = categories.filter(cat =>
    JSON.stringify(cat.content)
      .toLowerCase()
      .includes(searchVal && searchVal.toLowerCase())
  );
  const noResult = filteredCategories && filteredCategories.length === 0;

  return (
    <FaqDropdownContent
      searchVal={searchVal}
      isSearch={isSearch}
      noResult={noResult}
      categoryDisplayed={categories}
      selected={selected}
      category={category}
      FaqGeneral={faqGeneralContent(city)}
      FaqContact={FaqContact}
      FaqEligibility={faqEligibilityContent(city)}
      FaqEv={faqEVContent(city)}
      FaqReferral={FaqReferral}
      FaqSignup={FaqSignupContent(city)}
      FaqSafety={FaqSafety}
      closeSearch={closeSearch}
      setInput={setInput}
      setSearchVal={setSearchVal}
      searchResult={searchResult}
      setSearchResult={setSearchResult}
      handleSelected={handleSelected}
      setCategory={setCategory}
    />
  );
};

export default FaqDropdown;



// WEBPACK FOOTER //
// ./src/components/Static/NewGeneralFaq/FaqDropdown.js